import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatListOption, MatSelectionListChange } from '@angular/material/list';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InformationalDialogComponent, ErrorSeverity } from 'src/app/global/components/dialogs/informational-dialog/informational-dialog.component';
import { UserRecord } from '../../user.model';
import { UserService } from '../../service/user.abstract.service';
import { PostUserFamilyLinkPayload } from '../../user.model';
import { MessageService } from 'src/app/global/services/message/message.abstract.service';

interface DialogDataInput {
    results: any[];
    userRecord: UserRecord;
    payload: PostUserFamilyLinkPayload;
}

@Component({
    selector: 'app-user-search-results-dialog',
    templateUrl: './user-search-results-dialog.component.html',
    styleUrls: ['./user-search-results-dialog.component.scss'],
})
export class UserSearchResultsDialog implements OnInit, OnDestroy {
    destroy$ = new Subject();

    submitLoading: boolean;

    selectedResult: any;

    results: any[];

    constructor(
        private translateService: TranslateService,
        private userService: UserService,
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<UserSearchResultsDialog>,
        private messageService: MessageService,
        @Inject(MAT_DIALOG_DATA) public data: DialogDataInput,
    ) {}

    ngOnInit(): void {
        this.results = this.data.results;
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    closeDialog() {
        this.dialogRef.close();
    }

    onBack() {
        this.closeDialog();
    }

    onSelectChange(event: MatSelectionListChange) {
        const legacyEvent = event as MatSelectionListChange & { option?: MatListOption };
        const selected = legacyEvent.option ?? event.options?.[0] ?? null;
        this.selectedResult = selected?.value ?? null;
    }

    onSubmit() {
        this.submitLoading = true;
        this.userService
            .postUserFamilyLink(this.data.payload, this.data.userRecord.id, this.selectedResult._id)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (response) => {
                    this.submitLoading = false;
                    this.dialog.closeAll();
                    this.messageService.success(this.translateService.instant('pages.user-cards.user-search-results.messages.success'));
                },
                (error) => {
                    console.log(error);
                    this.submitLoading = false;
                    if (error.status === 400) {
                        this.dialogRef.addPanelClass('is-hidden');
                        this.dialog
                            .open(InformationalDialogComponent, {
                                panelClass: 'bciti-error-dialog',
                                data: {
                                    title: this.translateService.instant('pages.user-cards.user-search-results.messages.error'),
                                    body: error?.error?.messages[0],
                                    errorSeverity: ErrorSeverity.Error,
                                },
                            })
                            .afterClosed()
                            .subscribe(() => {
                                this.dialogRef.removePanelClass('is-hidden');
                            });
                    } else {
                        this.messageService.error(this.translateService.instant('pages.user-cards.user-search-results.messages.error'));
                    }
                },
            );
    }
}
